import { render, staticRenderFns } from "./SakaniAnalytics.vue?vue&type=template&id=3548dfba&scoped=true&"
import script from "./SakaniAnalytics.vue?vue&type=script&lang=js&"
export * from "./SakaniAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./SakaniAnalytics.vue?vue&type=style&index=0&id=3548dfba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548dfba",
  null
  
)

export default component.exports